export enum AllReservationsReportProducts {
    Vehicle = 'Vehicle',
    Hotel = 'Hotel',
    Air = 'Air',
    All = 'All',
  }

export interface TravelReportList {
    id: string,
    travelItineraryId: string;
    companyName: string;
    travelArrangerFullName: string;
    passengersList: string;
    userGroupName: string;
    costCenterCode: string;
    costCenterName: string;
    travelType: string;
    airTravelType: string;
    travelStatus: string;
    currencyCode: string;
    totalFare: string;
    totalVAT: string;
    totalOtherTaxes: string;
    totalTaxes: string;
    totalProvider: string;
    totalFees: string;
    totalPrice: string;
    paymentAuthorizationNumber1: string;
    valueAuthorizationNumber1: string;
    paymentAuthorizationNumber2: string;
    valueAuthorizationNumber2: string;
    creditCardLast4Digits: string;
    paymentStatus: string;
    paymentDate: string;
    paymentFailureReason: string;
    paymentReference: string;
    travelReason: string;
    breakingRulesJustify: string;
    breakingRulesMessage: string;
    breakingRules: string;
    travelJustify: string;
    travelRequiredApprovers: string;
    travelApprovers: string;
    travelCreatedDate: string;
    originCode: string;
    originName: string;
    originDate: string;
    destinationCode: string;
    destinationName: string;
    destinationDate: string;
    returnDate: string;
    airlineCode: string;
    airlineName: string;
    confirmationCode: string;
    ticketNumber: string;
    hotelName: string;
    hotelCheckin: string;
    hotelCheckout: string;
    vehiclePickup: string;
    vehicleDropoff: string;
    vehiclePickupLocationCode: string;
    vehiclePickupLocation: string;
    vehicleDropoffLocationCode: string;
    vehicleDropoffLocation: string;
    vehicleCompany: string;
    vehicleModel: string;
    lowestLogicalFare: string;
    hasPrivateFare: boolean;
    privateRateCode: string;
}

export interface AllReservationsReportRequest {
  pageNumber: number;
  pageSize: number;
  travelItineraryId?: string;
  companyIdReport?: string;
  costCenterId?: string;
  reservationStartDate?: string;
  reservationEndDate?: string;
  travelStatus?: string;
  userGroupId?: string;
  breakRuleReasonId?: string;

  userId?: string;
  rejectedReasonId?: string;
  reservationCreatedStartDate?: string;
  reservationCreatedEndDate?: string;
  travelType?: string;
}

export interface AllReservationsReportResponse {
  currentPageNumber: number;
  currentPageSize: number;
  totalResults: number;
  travelReportList: TravelReportList[];
}
